export default "__VITE_ASSET__UZnqnNwD__"